// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationFilledSvg from "@ant-design/icons-svg/es/asn/ReconciliationFilled";
import AntdIcon from '../components/AntdIcon';

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationFilledSvg
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
export default React.forwardRef(ReconciliationFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ReconciliationFilled.js
// module id = 1677
// module chunks = 0